/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Grade {
  baseApi = ENV.BASE_API;

  async getGrades(accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.GRADE}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getGradesByLevelId(levelId, accessToken) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.GRADE}/level/${levelId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createGrade(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.GRADE}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateGrade(accessToken, gradeId, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.GRADE}/${gradeId}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteGrade(accessToken, gradeId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.GRADE}/${gradeId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
